import {StoreType} from '../../../types/sharedTypes';

export const allSuppliersSelector = (state: StoreType) => {
  return state.supplierReducer.suppliersResult;
}
